<template lang="html">
    <div>
       <v-toolbar text color="white">
        <v-toolbar-title>TRANSPORT METHODS OF PAYMENT CODES ({{getData.length}})</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
        <br>
         <v-card-title class="justify-content-end">
            <v-flex md4 pr-2 >
                <v-text-field v-model="search" label="Search"
                append-icon="mdi-magnify" single-line hide-details ></v-text-field>
            </v-flex>
        </v-card-title>
      <v-data-table :headers="headers" :items="getData" 
           :search="search" class="elevation-1">
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-right" >{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.name }}</td>
          </tr>
        </template>
<template v-slot:no-data>
          <span>No data found</span>
        </template>
</v-data-table>

</div>
</template>

<script>
    import MasterScreenService from "../../services/master-screenservices"

    export default {
        name: 'TransportMethodsOfPayment',
        data() {
            return {
                search: '',
                getData: [],
                headers: [{
                    text: "Code",
                    align: "left",
                    sortable: true,
                    value: "code"
                }, {
                    text: "Name",
                    align: "left",
                    sortable: true,
                    value: "name"
                }, ],
            }
        },
        computed: {},
        created() {
            MasterScreenService.getTransportMethodsPayment().then(response => {
                    this.getData = response.data;
                    console.log(this.getData);
                })
                .catch(e => {
                    console.log(e);
                });
        },

        methods: {}
    }
</script>

<style>
    .justify-content-end {
        justify-content: Flex-end;
    }
</style>